export const environment = {
  restApiServer: 'https://apisurveymanager.ankaha.com',
  production: true
};




// WEBPACK FOOTER //
// ./src/environments/environment.ts